import * as React from "react"
import SaDefaultImageText from "./saDefaultImageText"

// @ts-ignore
import { saDefaultImageTextSection } from './saDefaultImageText.module.scss'
import { saInterfaceImageText } from "../saTypes"



export const SaDefaultImageTextContainer:React.FC<saInterfaceImageText> = (props) =>{

    return (
      <section className={saDefaultImageTextSection + ' ' +  props.className }>
        <SaDefaultImageText {...props}/>
      </section>
    )

}
